import {SET_REDIRECT} from './types';

export const redirectAction = (route) => (dispatch) => {

    dispatch({
        type: SET_REDIRECT,
        payload: route || null
    });
};
